import { RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { Lightning } from '@lightningjs/sdk';
import _get from 'lodash/get';
import _merge from 'lodash/merge';
import Icon from '../../icon/icon.component';
import { DETACHED_SIGNAL, INACTIVE_SIGNAL, SELECTED_SIGNAL } from '../../signals';
import { areContentItemsEqual, areContextsEqual } from '../../utils/templates';
import ImageShader from '../../shaders/image.shader';
import FocusShader from '../../shaders/focus.shader';
import {
  getLockIconViewBox,
  getFocusedStyle,
  unFocusedStyle,
  getInitialStyle,
  defaultContext,
  sizes,
} from './heroNav.style';

/**
 * The HeroNav is used to navigate through the Hero organism on TV.
 *
 * @version 1.0.2
 * @see https://zeroheight.com/726d5c282/p/19e373-heronav--v102/t/page-19e373-70498684-587e71-1
 */
export default class HeroPoster extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Border: {
          rect: true,
          shader: {
            type: FocusShader,
          },
        },
        Image: {
          shader: {
            type: ImageShader,
          },
        },
        LockIcon: {
          type: Icon,
        },
      },
      getInitialStyle(this._style),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _inactive() {
    this.signal(INACTIVE_SIGNAL, this);
  }

  _detach() {
    this._item = undefined;
    this.signal(DETACHED_SIGNAL, this);
  }

  get item() {
    return this._item;
  }

  set item({
    content,
    config,
    template,
    colorScheme = this._style.colorMode,
    renderingContext = RENDERING_CONTEXT.GENERAL,
  }) {
    const { screenSize } = this._style;
    const templateDataAccessPath = [template, renderingContext, screenSize];
    if (areContentItemsEqual(this._item, content) && areContextsEqual(this._renderingContext, renderingContext)) {
      this._item = content;

      return;
    }

    this._renderingContext = renderingContext;
    this._item = content;
    this._config = config || { ..._get(sizes, templateDataAccessPath, {}) };
    this._style.colorMode = colorScheme;

    const { secondaryImage, lockPicto } = this._item;

    this.patch({
      Image: {
        src: secondaryImage && secondaryImage.src,
      },
      LockIcon: {
        iconData: {
          picto: lockPicto,
          viewBox: getLockIconViewBox(this._style.screenSize),
        },
      },
    });
  }

  _focus() {
    this.patch(getFocusedStyle(this._style));
  }

  _unfocus() {
    this.patch(unFocusedStyle);
  }

  _handleEnter() {
    this.signal(SELECTED_SIGNAL, this._item);

    return true;
  }
}
